import loadProjectActions from './actions';
import loadSavedProducts from './savedProducts';

export default {
    ...loadProjectActions,
    ...loadSavedProducts,
};
